import api from '../..';

export default ({ code }) => api.get(`/tourclient/api/orderapi/PaymentSystemUrls?AgreementCode=${encodeURIComponent(code)}`, { formatting: true })
  .then((data) => (data?.data?.items || []).map((i, j) => ({
    label: i.key,
    value: i.value.paySystem,
    key: `${i.key}-${j}`,
    system: i.value.paySystem,
    link: i.value.link === '_' ? '' : i.value.link,
    price: i.value.amount,
    comment: i.value.comment,
    methods: i.value.methods,
    isHide: !!i.value.hiddenByDefault,
    isOffer: !!i.value.withPublicOffer,
  })));



